import { type CommonAction, success } from "@iflyrpa/share";
import type { ActiomCommonParams } from "../../types";
import { Http } from "../../utils/http";

export interface GetWeixinCollectionParams extends ActiomCommonParams {
    token: string | number;
}

export interface CollectDetailResponse {
    base_resp: { err_msg: string; ret: number };
    list_resp: { items: CollectDetail[]; total: number };
}

export interface CollectDetail {
    continous_read_on: number;
    cover_url: string;
    create_time: number;
    id: string;
    is_ban: number;
    is_updating: number;
    need_pay: number;
    title: string;
    total: number;
    type: number;
    update_time: number;
    url: string;
    uv: number;
}

export type PublishAction = CommonAction<GetWeixinCollectionParams, CollectDetail[]>;

export const getWeixinCollection: PublishAction = async (_task, params) => {
    const http = new Http({
        headers: {
            cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        },
    });
    const fingerprint = "4695500bc93ab4ce8fb2692da6564e04";

    const res = await http.api<CollectDetailResponse>({
        method: "get",
        url: "https://mp.weixin.qq.com/cgi-bin/appmsgalbummgr",
        params: {
            action: "list",
            begin: 0,
            count: 100,
            sub_title: "",
            type: 0,
            latest: 1,
            need_pay: 0,
            fingerprint,
            token: params.token,
            lang: "zh_CN",
            f: "json",
            ajax: 1,
        },
    });

    return success(
        res.list_resp?.items ?? [],
        res.base_resp.ret === 0 ? "微信合计信息获取成功！" : "微信合集信息获取失败！",
    );
};
